import { ItemID } from "types/common";

export const getItemClassFromItemId = (itemID: ItemID): [itemClass: string, idNumber: string] => {
  const [, itemClass, IDNumber] = itemID.split("/");
  return [itemClass, IDNumber];
};
